module.exports = __webpack_public_path__ + "static/media/wikireader.61219c65.png";